/**
 * @desc 根据平台订单号查询是否有退款单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/rpc/asRefundOrder/refundOrderList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
